export default "__VITE_ASSET__b7efdcc2__"